import React from 'react';
import moment from 'moment';
import { Button, Form, Input, Row, Col, Select, message } from 'antd';
const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;
import { observer, inject } from 'mobx-react';
import styles from './DeviceDetail.less';
import { getValueLabel } from '../../lib/lib';
import { formItemLayout } from '../../const/FormConst';

const BYTE = 1024;
@inject('deviceInfoDetailStore')
@observer
class Tab1Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorRemark: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.props.deviceInfoDetailStore.form = this.props.form;
  }
  handleSubmit() {
    this.props.form.validateFields((error, value) => {
      if (!error) {
        this.setState({
          editorRemark: !this.state.editorRemark
        });
        if (this.state.editorRemark) {
          this.props.deviceInfoDetailStore
            .postDeviceMemo(
              value.remark,
              this.props.deviceInfoDetailStore.deviceDetail['device_id']
            )
            .then(json => {
              if (json.code === 200) {
                message.success('保存备注成功');
                this.props.form.setFieldsValue({ remark: value.remark });
              } else {
                message.error(json.message);
              }
            });
        }
      }
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { deviceDetail } = this.props.deviceInfoDetailStore;
    return (
      <div className={styles.deviceInfoTab1}>
        <Row className={styles.textContainer}>
          <Col span={2} offset={1} className={styles.label}>
            设备编号:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {deviceDetail['device_id'] || '--'}
          </Col>
          <Col span={4} offset={1} className={styles.label}>
            设备型号:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {deviceDetail.model || '--'}
          </Col>
        </Row>
        <Row className={styles.textContainer}>
          <Col span={2} offset={1} className={styles.label}>
            定位地址:
          </Col>
          <Col span={20} offset={1} className={styles.value}>
            {deviceDetail.address || '--'}
          </Col>
        </Row>
        <Row className={styles.textContainer}>
          <Col span={2} offset={1} className={styles.label}>
            设备租期:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {deviceDetail['expire_time'] || '--'}
          </Col>
          <Col span={4} offset={1} className={styles.label}>
            固件版本:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {deviceDetail['firmware_version'] || '--'}
          </Col>
        </Row>
        <Row className={styles.textContainer}>
          <Col span={2} offset={1} className={styles.label}>
            内存使用率:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {getValueLabel(deviceDetail['memory_usage'], 2, '%')}
          </Col>
          <Col span={4} offset={1} className={styles.label}>
            自统计移动流量(月):
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {getValueLabel(deviceDetail['data_traffic'] / BYTE, 2, 'MB')}
          </Col>
        </Row>
        <Row className={styles.textContainer}>
          <Col span={2} offset={1} className={styles.label}>
            存储占用率:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {getValueLabel(deviceDetail['storage_usage'], 2, '%')}
          </Col>
          <Col span={4} offset={1} className={styles.label}>
            运营商统计移动流量(月):
          </Col>
          <Col span={6} offset={1} className={styles.value}>
            {getValueLabel(deviceDetail['operator_network_usage'], 2, 'MB')}
          </Col>
        </Row>
        <Row className={styles.textContainer}>
          <Col span={2} offset={1} className={styles.label}>
            CPU使用率:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {getValueLabel(deviceDetail['cpu_usage'], 2, '%')}
          </Col>
          <Col span={4} offset={1} className={styles.label}>
            宽带流量(月):
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {getValueLabel(deviceDetail['network_usage'] / BYTE, 2, 'MB')}
          </Col>
        </Row>
        <Row className={styles.textContainer}>
          <Col span={2} offset={1} className={styles.label}>
            IMEI:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {deviceDetail.imei || '--'}
          </Col>
          <Col span={4} offset={1} className={styles.label}>
            ICCID:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {deviceDetail.iccid || '--'}
          </Col>
        </Row>
        <Row className={styles.textContainer}>
          <Col span={2} offset={1} className={styles.label}>
            当前网络连接:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {deviceDetail.network && deviceDetail.network.length
              ? deviceDetail.network.join(',')
              : '--'}
          </Col>
          <Col span={4} offset={1} className={styles.label}>
            所在分组:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {deviceDetail['tag'] ? deviceDetail['tag'].join(', ') : '--'}
          </Col>
        </Row>
        <Row className={styles.textContainer} style={{ height: 45 }}>
          <Col span={2} offset={1} className={styles.label}>
            MAC地址:
          </Col>
          <Col span={7} offset={1} className={styles.valueWrap}>
            {deviceDetail.mac ? deviceDetail.mac.join(', ') : '--'}
          </Col>
          <Col span={4} offset={1} className={styles.label}>
            客户名称:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {deviceDetail.client || '--'}
          </Col>
        </Row>
        <Row className={styles.textContainer}>
          <Col span={2} offset={1} className={styles.label}>
            最后在线时间:
          </Col>
          <Col span={7} offset={1} className={styles.value}>
            {deviceDetail['last_online_time']
              ? moment(deviceDetail['last_online_time']).format(
                  'YYYY-MM-DD HH:mm:ss'
                )
              : '--'}
          </Col>
          <Col span={12} offset={1}>
            <Form onSubmit={this.handleSubmit}>
              <Row>
                <Col span={12}>
                  <FormItem {...formItemLayout} label="备注">
                    {getFieldDecorator('remark')(
                      <TextArea
                        placeholder="编辑备注信息"
                        disabled={!this.state.editorRemark}
                      />
                    )}
                  </FormItem>
                </Col>
                <Col span={2} offset={2}>
                  <Button type="primary" onClick={this.handleSubmit}>
                    {!this.state.editorRemark ? '编辑备注' : '保存备注'}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}
const Tab1 = Form.create()(Tab1Component);
export default Tab1;



// WEBPACK FOOTER //
// ./src/components/DeviceInfo/DeviceDetail.js